export default "__VITE_ASSET__9642c0ad__"